"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var create_hmac_1 = __importDefault(require("create-hmac"));
var secp256k1_1 = require("./secp256k1");
// the BIP32 class is inspired from https://github.com/bitcoinjs/bip32/blob/master/src/bip32.js
var BIP32 = /** @class */ (function () {
    function BIP32(publicKey, chainCode, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    network, depth, index) {
        if (depth === void 0) { depth = 0; }
        if (index === void 0) { index = 0; }
        (0, invariant_1["default"])(publicKey && publicKey.length > 0, "publicKey must not be empty");
        (0, invariant_1["default"])(chainCode && chainCode.length > 0, "chainCode must not be empty");
        this.publicKey = publicKey;
        this.chainCode = chainCode;
        this.network = network;
        this.depth = depth;
        this.index = index;
    }
    BIP32.prototype.derive = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            var data, I, IL, IR, Ki, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = Buffer.allocUnsafe(37);
                        this.publicKey.copy(data, 0);
                        data.writeUInt32BE(index, 33);
                        I = (0, create_hmac_1["default"])("sha512", this.chainCode).update(data).digest();
                        IL = I.slice(0, 32);
                        IR = I.slice(32);
                        _b = (_a = Buffer).from;
                        return [4 /*yield*/, (0, secp256k1_1.getSecp256k1Instance)().publicKeyTweakAdd(this.publicKey, IL)];
                    case 1:
                        Ki = _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, new BIP32(Ki, IR, this.network, this.depth + 1, index)];
                }
            });
        });
    };
    return BIP32;
}());
exports["default"] = BIP32;
//# sourceMappingURL=bip32.js.map